import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './InteractiveGoogleMap.css';
import React, { useEffect, useState, useRef } from 'react';
import useSupercluster from 'use-supercluster';
import GoogleMapReact from 'google-map-react';
import MarkerInfoItem from './components/MarkerInfoItem';
import { canUseDOM, get } from '../../../utils';
import { stylesOldCarousel } from '../../../utils/OldCarouselDotsStyles';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
var Marker = function Marker(_ref) {
  var children = _ref.children;
  return children;
};
var convertDataToGEOJson = function convertDataToGEOJson(markers) {
  return markers.map(function (el) {
    var lng = el._geoloc.lng,
      lat = el._geoloc.lat,
      objectID = el.objectID;
    if (objectID && lng && lat) {
      return {
        type: 'Feature',
        properties: {
          category: 'wells',
          cluster: false,
          wellId: "".concat(objectID)
        },
        geometry: {
          type: 'Point',
          coordinates: [lng, lat]
        },
        data: el
      };
    }
  });
};
var mapStyles = [{
  featureType: 'water',
  elementType: 'geometry',
  stylers: [{
    color: '#C7C7C7'
  }, {
    lightness: 17
  }]
}, {
  featureType: 'landscape',
  elementType: 'geometry',
  stylers: [{
    color: '#f5f5f5'
  }, {
    lightness: 20
  }]
}, {
  featureType: 'road.highway',
  elementType: 'geometry.fill',
  stylers: [{
    color: '#ffffff'
  }, {
    lightness: 17
  }]
}, {
  featureType: 'road.highway',
  elementType: 'geometry.stroke',
  stylers: [{
    color: '#ffffff'
  }, {
    lightness: 29
  }, {
    weight: 0.2
  }]
}, {
  featureType: 'road.arterial',
  elementType: 'geometry',
  stylers: [{
    color: '#ffffff'
  }, {
    lightness: 18
  }]
}, {
  featureType: 'road.local',
  elementType: 'geometry',
  stylers: [{
    color: '#ffffff'
  }, {
    lightness: 16
  }]
}, {
  featureType: 'poi',
  elementType: 'geometry',
  stylers: [{
    color: '#f5f5f5'
  }, {
    lightness: 21
  }]
}, {
  featureType: 'poi.park',
  elementType: 'geometry',
  stylers: [{
    color: '#dedede'
  }, {
    lightness: 21
  }]
}, {
  elementType: 'labels.text.stroke',
  stylers: [{
    visibility: 'on'
  }, {
    color: '#ffffff'
  }, {
    lightness: 16
  }]
}, {
  elementType: 'labels.text.fill',
  stylers: [{
    saturation: 36
  }, {
    color: '#333333'
  }, {
    lightness: 40
  }]
}, {
  elementType: 'labels.icon',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'transit',
  elementType: 'geometry',
  stylers: [{
    color: '#f2f2f2'
  }, {
    lightness: 19
  }]
}, {
  featureType: 'administrative',
  elementType: 'geometry.fill',
  stylers: [{
    color: '#fefefe'
  }, {
    lightness: 20
  }]
}, {
  featureType: 'administrative',
  elementType: 'geometry.stroke',
  stylers: [{
    color: '#fefefe'
  }, {
    lightness: 17
  }, {
    weight: 1.2
  }]
}];
var InteractiveGoogleMap = function InteractiveGoogleMap(_ref2) {
  var mapState = _ref2.mapState,
    callback = _ref2.callback,
    handleGetHitsFromMap = _ref2.handleGetHitsFromMap,
    handleGetActiveItemId = _ref2.handleGetActiveItemId,
    dictionary = _ref2.dictionary,
    centreMapLongitude = _ref2.centreMapLongitude,
    centreMapLatitude = _ref2.centreMapLatitude,
    defaultMapZoom = _ref2.defaultMapZoom,
    analytics = _ref2.analytics,
    params = _ref2.params,
    rtl = _ref2.rtl,
    activePopupItem = _ref2.activePopupItem,
    activeTopPicks = _ref2.activeTopPicks,
    toggleActiveTopPicks = _ref2.toggleActiveTopPicks;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    bounds = _useState2[0],
    setBounds = _useState2[1];
  var _useState3 = useState(defaultMapZoom),
    _useState4 = _slicedToArray(_useState3, 2),
    zoom = _useState4[0],
    setZoom = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    activeMarker = _useState6[0],
    setActiveMarker = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    markers = _useState8[0],
    setMarkers = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    shouldListBeRerendered = _useState10[0],
    setShouldListBeRerendered = _useState10[1];
  var _useState11 = useState({
      lat: Number(centreMapLatitude),
      lng: Number(centreMapLongitude)
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    dafaultCenter = _useState12[0],
    setDefaultCenter = _useState12[1];
  var mapRef = useRef();
  var maxZoom = 16;
  var maxMapZoom = 20;
  var arrangePinsInCircle = function arrangePinsInCircle(centerX, centerY, radius, numberOfPins) {
    var positions = [];
    var angleStep = 2 * Math.PI / numberOfPins;
    for (var i = 0; i < numberOfPins; i++) {
      var angle = i * angleStep;
      var x = centerX + radius * Math.cos(angle);
      var y = centerY + radius * Math.sin(angle);
      positions.push({
        lat: y,
        lng: x
      });
    }
    return positions;
  };
  var filterPins = function filterPins(markers) {
    var finalArr = [];
    var getAllMarkersArr = markers.map(function (el) {
      return {
        id: el.properties.wellId,
        lat: el.data._geoloc.lat,
        lng: el.data._geoloc.lng
      };
    });
    var getAllLatitudeDublicatesArr = getAllMarkersArr.reduce(function (acc, item) {
      var lat = item.lat;
      (acc[lat] = acc[lat] || []).push(item);
      return acc;
    }, {});
    var _loop = function _loop() {
      var dublicatedByLatitudeArray = getAllLatitudeDublicatesArr[property];
      if (dublicatedByLatitudeArray.length > 1) {
        // X-coordinate of the center point
        var centerX = dublicatedByLatitudeArray[0].lng;
        // Y-coordinate of the center point
        var centerY = dublicatedByLatitudeArray[0].lat;
        // Radius of the circle
        var radius = 0.00005;
        // Number of pins
        var numberOfPins = dublicatedByLatitudeArray.length;
        var pinPositions = arrangePinsInCircle(centerX, centerY, radius, numberOfPins);
        dublicatedByLatitudeArray.map(function (el, i) {
          el.lat = pinPositions[i].lat;
          el.lng = pinPositions[i].lng;
          finalArr.push(el);
        });
      }
    };
    for (var property in getAllLatitudeDublicatesArr) {
      _loop();
    }
    finalArr = markers.map(function (el) {
      var updatedItemWithNewCoordinates = finalArr.filter(function (item) {
        return el.properties.wellId === item.id;
      });
      if (updatedItemWithNewCoordinates.length) {
        var _updatedItemWithNewCo = updatedItemWithNewCoordinates[0],
          lat = _updatedItemWithNewCo.lat,
          lng = _updatedItemWithNewCo.lng;
        el.data._geoloc.lat = Number(lat);
        el.data._geoloc.lng = Number(lng);
        el.geometry.coordinates[0] = Number(lng);
        el.geometry.coordinates[1] = Number(lat);
      }
      return el;
    });
    return finalArr;
  };
  useEffect(function () {
    if (mapState && mapState.markers) {
      clearActiveMarkerId();
      var convertedMarkers = convertDataToGEOJson(mapState.markers);
      convertedMarkers = filterPins(convertedMarkers);
      if (mapRef.current && convertedMarkers && convertedMarkers.length) {
        var lat = convertedMarkers[0] === undefined ? null : convertedMarkers[0].geometry.coordinates[1];
        var lng = convertedMarkers[0] === undefined ? null : convertedMarkers[0].geometry.coordinates[0];
        if (lat && lng) {
          setZoom(defaultMapZoom);
          mapRef.current.setZoom(defaultMapZoom);
          mapRef.current.panTo({
            lat: lat,
            lng: lng
          });
        }
      }
      setMarkers(convertedMarkers);
      centerMap();
    }
  }, [mapState]);
  var _useSupercluster = useSupercluster({
      points: markers,
      bounds: bounds,
      zoom: zoom,
      options: {
        radius: 85,
        maxZoom: maxZoom
      }
    }),
    clusters = _useSupercluster.clusters,
    supercluster = _useSupercluster.supercluster;
  React.useEffect(function () {
    if (shouldListBeRerendered) {
      updateMarkersToTheList();
    }
  }, [clusters, shouldListBeRerendered]);
  React.useEffect(function () {
    if (activePopupItem) {
      var objectID = activePopupItem.objectID,
        lat = activePopupItem.lat,
        lng = activePopupItem.lng;
      setActiveMarker(objectID);
      handleGetActiveItemId(objectID);
      mapRef.current.setZoom(maxZoom + 1);
      mapRef.current.panTo({
        lat: lat,
        lng: lng
      });
    }
  }, [activePopupItem]);
  var _handleChangeValue = function _handleChangeValue(_ref3) {
    var zoom = _ref3.zoom,
      bounds = _ref3.bounds;
    setZoom(zoom);
    setBounds([bounds.nw.lng, bounds.se.lat, bounds.se.lng, bounds.nw.lat]);
  };
  var handleActiveMarker = function handleActiveMarker(objectID, latitude, longitude) {
    mapRef.current.panTo({
      lat: latitude,
      lng: longitude
    });
    setActiveMarker(objectID);
    handleGetActiveItemId(objectID);
  };
  var clearActiveMarkerId = function clearActiveMarkerId() {
    setActiveMarker(null);
    handleGetActiveItemId(null);
  };
  var updateMarkersToTheList = function updateMarkersToTheList() {
    handleGetHitsFromMap(clusters);
  };
  var centerMap = function centerMap() {
    if (mapRef.current) {
      mapRef.current.setZoom(10);
      mapRef.current.panTo(dafaultCenter);
    }
  };
  var getClusterIconSize = function getClusterIconSize(count) {
    if (count >= 100) {
      return 68;
    }
    return 42;
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "im-google-map"
  }, /*#__PURE__*/React.createElement("div", {
    className: "im-google-map-wrapper"
  }, /*#__PURE__*/React.createElement(GoogleMapReact, {
    bootstrapURLKeys: {
      key: !process.env.STORYBOOK_MODE && canUseDOM ? get(window, 'map_key') : 'AIzaSyB4GL2flAQBGxzOjrbVXQUvpU2UqJfoPo8'
    },
    defaultCenter: dafaultCenter,
    defaultZoom: 10,
    yesIWantToUseGoogleMapApiInternals: true,
    onGoogleApiLoaded: function onGoogleApiLoaded(_ref4) {
      var map = _ref4.map;
      callback();
      mapRef.current = map;
    },
    options: {
      fullscreenControl: false,
      zoomControl: false,
      clickableIcons: false,
      styles: mapStyles
    },
    onChange: _handleChangeValue,
    onZoomAnimationStart: function onZoomAnimationStart() {
      if (!shouldListBeRerendered) {
        setShouldListBeRerendered(true);
      }
    },
    onDragEnd: function onDragEnd() {
      clearActiveMarkerId();
      if (!shouldListBeRerendered) {
        setShouldListBeRerendered(true);
      }
    },
    onClick: function onClick(e) {
      if (e.event.target.nodeName !== 'svg' && e.event.target.nodeName !== 'path' && !e.event.target.className.includes('carousel-icon') && !e.event.target.className.includes('imfilters-listing-item__fav-btn') && !e.event.target.className.includes('dot')) {
        clearActiveMarkerId();
      }
    }
  }, clusters && clusters.map(function (cluster) {
    var _cluster$geometry$coo = _slicedToArray(cluster.geometry.coordinates, 2),
      longitude = _cluster$geometry$coo[0],
      latitude = _cluster$geometry$coo[1];
    var _cluster$properties = cluster.properties,
      isCluster = _cluster$properties.cluster,
      pointCount = _cluster$properties.point_count;
    if (isCluster) {
      return /*#__PURE__*/React.createElement(Marker, {
        lat: latitude,
        lng: longitude,
        key: "cluster-".concat(cluster.id),
        className: "cluster-marker"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "cluster-marker",
        style: {
          width: "".concat(getClusterIconSize(pointCount), "px"),
          height: "".concat(getClusterIconSize(pointCount), "px")
        },
        onClick: function onClick() {
          if (supercluster && mapRef.current && cluster.id) {
            var expansionZoom = Math.min(supercluster.getClusterExpansionZoom(Number(cluster.id)), maxMapZoom);
            mapRef.current.setZoom(expansionZoom);
            mapRef.current.panTo({
              lat: latitude,
              lng: longitude
            });
          }
        }
      }, pointCount));
    } else {
      return /*#__PURE__*/React.createElement(Marker, {
        key: "cluster-".concat(cluster.properties.wellId),
        lat: latitude,
        lng: longitude
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "well-marker ".concat(activeMarker === cluster.data.objectID ? 'active' : '', " "),
        onClick: function onClick() {
          handleActiveMarker(cluster.data.objectID, latitude, longitude);
          if (!shouldListBeRerendered) {
            setShouldListBeRerendered(true);
          }
          tealiumClickFunc(tealiumMergeClickData(analytics['mapPinAnalytics'], params), "".concat(cluster.data.title ? cluster.data.title : ''));
        }
      }, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "34.661",
        height: "43.564",
        viewBox: "0 0 34.661 43.564"
      }, /*#__PURE__*/React.createElement("g", {
        id: "Group_2156",
        "data-name": "Group 2156",
        transform: "translate(0.25 0.248)"
      }, /*#__PURE__*/React.createElement("circle", {
        id: "Ellipse_812",
        "data-name": "Ellipse 812",
        cx: "8",
        cy: "8",
        r: "8",
        transform: "translate(8.242 8.001)",
        fill: "#fff"
      }), /*#__PURE__*/React.createElement("path", {
        id: "Subtraction_303",
        "data-name": "Subtraction 303",
        d: "M-6444.792-1902.43a1.6,1.6,0,0,1-1.138-.471,97.37,97.37,0,0,1-10.713-12.333c-3.481-5.037-5.233-9.624-5.356-14.021v-.084a16.619,16.619,0,0,1,4.978-11.292,17.139,17.139,0,0,1,11.757-4.861c.118,0,.236,0,.354,0a17.5,17.5,0,0,1,11.894,4.567,15.742,15.742,0,0,1,5.176,11.2v.01c.069,4.334-1.292,8.617-4.163,13.093a79.472,79.472,0,0,1-9.049,10.926l-.044.047c-.872.934-1.695,1.816-2.505,2.709a1.592,1.592,0,0,1-1.153.512Zm.292-31.561a4.5,4.5,0,0,0-4.5,4.5,4.505,4.505,0,0,0,4.5,4.5,4.506,4.506,0,0,0,4.5-4.5A4.5,4.5,0,0,0-6444.5-1933.991Z",
        transform: "translate(6462 1945.497)",
        fill: activeMarker === cluster.data.objectID ? '#2B2B2B' : cluster.data.color,
        stroke: "#646464",
        "stroke-width": "0.5"
      })))), activeMarker === cluster.data.objectID ? /*#__PURE__*/React.createElement(MarkerInfoItem, _extends({}, cluster.data, {
        dictionary: dictionary,
        analytics: analytics,
        params: params,
        rtl: rtl,
        activeTopPicks: activeTopPicks,
        toggleActiveTopPicks: toggleActiveTopPicks
      })) : null);
    }
  })), /*#__PURE__*/React.createElement("button", {
    className: "default-center-btn icon-btn",
    name: "name",
    onClick: function onClick() {
      centerMap();
      clearActiveMarkerId();
      tealiumClickFunc(tealiumMergeClickData(analytics['mapInteractionsAnalytics'], params), 'home');
    }
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16.282",
    height: "16.169",
    viewBox: "0 0 16.282 16.169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15486",
    "data-name": "Group 15486",
    transform: "translate(-1883.657 -944.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M1890.822,901.913l-6.446,5.125.455,8.291,2.661.56,1.681-.243.163-5.84,2.729-.726,1.442.339,1.288,1.355-.177,4.352,3.574.52,1.072-.916v-6.774l-.5-1.744L1892.4,901.4Z",
    transform: "translate(0 44)",
    fill: "#035e88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M16.992,7.094,10.776,2.359a1.681,1.681,0,0,0-2.031,0L2.531,7.093A1.684,1.684,0,0,0,1.87,8.426V15.96a1.677,1.677,0,0,0,1.675,1.675H7.254a.559.559,0,0,0,.558-.558V11.458a.559.559,0,0,1,.558-.558h2.781a.559.559,0,0,1,.558.558v5.618a.559.559,0,0,0,.558.558h3.708a1.677,1.677,0,0,0,1.675-1.675V8.426A1.684,1.684,0,0,0,16.992,7.094Zm-.457,8.866a.559.559,0,0,1-.558.558h-3.15v-5.06a1.677,1.677,0,0,0-1.675-1.675H8.371A1.677,1.677,0,0,0,6.7,11.458v5.06H3.545a.559.559,0,0,1-.558-.558V8.426a.561.561,0,0,1,.22-.444L9.423,3.248a.56.56,0,0,1,.677,0l6.216,4.735a.561.561,0,0,1,.22.444V15.96Z",
    transform: "translate(1882.037 942.755)",
    fill: "#035e88",
    stroke: "#035e88",
    "stroke-width": "0.5"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "zoom-btns"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "icon-btn zoom-plus",
    name: "zoom in",
    disabled: mapRef.current ? mapRef.current.getZoom() === maxMapZoom + 1 : false,
    onClick: function onClick() {
      if (mapRef.current) {
        var currentZoom = mapRef.current.getZoom();
        if (currentZoom != maxMapZoom + 1) {
          mapRef.current.setZoom(currentZoom + 1);
          tealiumClickFunc(tealiumMergeClickData(analytics['mapInteractionsAnalytics'], params), 'zoom in');
        }
      }
    }
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.875",
    height: "10.875",
    viewBox: "0 0 10.875 10.875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1244",
    "data-name": "Group 1244",
    transform: "translate(-1885.5 -940.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_241",
    "data-name": "Line 241",
    y2: "8.875",
    transform: "translate(1890.937 941.5)",
    fill: "none",
    stroke: "#035e88",
    "stroke-linecap": "round",
    "stroke-width": "2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_242",
    "data-name": "Line 242",
    y2: "8.875",
    transform: "translate(1895.375 945.937) rotate(90)",
    fill: "none",
    stroke: "#035e88",
    "stroke-linecap": "round",
    "stroke-width": "2"
  })))), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "icon-btn zoom-minus",
    name: "zoom out",
    disabled: mapRef.current ? mapRef.current.getZoom() === 3 : false,
    onClick: function onClick() {
      if (mapRef.current) {
        var currentZoom = mapRef.current.getZoom();
        if (currentZoom != 3) {
          mapRef.current.setZoom(currentZoom - 1);
          tealiumClickFunc(tealiumMergeClickData(analytics['mapInteractionsAnalytics'], params), 'zoom out');
        }
      }
    }
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.875",
    height: "2",
    viewBox: "0 0 10.875 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1245",
    "data-name": "Group 1245",
    transform: "translate(-1885.5 -944.937)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_242",
    "data-name": "Line 242",
    y2: "8.875",
    transform: "translate(1895.375 945.937) rotate(90)",
    fill: "none",
    stroke: "#035e88",
    "stroke-linecap": "round",
    "stroke-width": "2"
  }))))))));
};
var StyledWrapper = function StyledWrapper(_ref5) {
  var children = _ref5.children,
    rtl = _ref5.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: " ".concat(commonStyles, " ").concat(stylesOldCarousel, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "c1o5xrtf";
var ltrStyles = "l1oxac3";
var rtlStyles = "r1818wo0";
export default InteractiveGoogleMap;